import React, { useState } from "react";
import {
  FaPhoneAlt,
  FaMapMarkerAlt,
  FaEnvelope,
  FaWhatsapp,
} from "react-icons/fa";

const C = {
  white: "#FFFFFF",
  black: "#111111",
  burgundy: "#7A1F2B",
  cream: "#f5f3ef",
};

const PRACTICE_AREAS = [
  "Anticipatory Bail",
  "Cheque Bounce (N.I. Act)",
  "Murder & Homicide Defense",
  "Dowry Harassment (Sec 498A)",
  "Debt Recovery Tribunal (DRT)",
  "Other",
];

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    area: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const handleSubmit = (e) => {
    e.preventDefault();
    const { name, email, phone, area, subject, message } = formData;
    const text = `New Enquiry:%0AName: ${name}%0AEmail: ${email}%0APhone: ${phone}%0APractice Area: ${area}%0ASubject: ${subject}%0AMessage: ${message}`;
    window.open(
      `https://wa.me/917042513698?text=${text}`,
      "_blank",
      "noopener noreferrer"
    );
    setFormData({ name: "", email: "", phone: "", area: "", subject: "", message: "" });
  };

  return (
    <section style={{ backgroundColor: C.cream }} className="w-full font-serif">
      {/* Top Rule */}
      <div style={{ height: 3, backgroundColor: C.burgundy }} />

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-10 md:py-14">

        {/* Header */}
        <div
          className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 px-8 py-8 border-b"
          style={{ backgroundColor: C.white, border: `1px solid ${C.black}`, borderBottom: "1px solid #e0ddd8" }}
        >
          <div>
            <p
              className="text-[10px] uppercase tracking-[0.45em] font-sans font-bold mb-3"
              style={{ color: C.burgundy }}
            >
              Rai &amp; Associates
            </p>
            <h2
              className="text-3xl md:text-4xl font-black leading-tight"
              style={{ color: C.black }}
            >
              Schedule a{" "}
              <em className="font-light italic" style={{ color: "#555" }}>
                Consultation
              </em>
            </h2>
          </div>
          <div
            className="text-[9px] uppercase tracking-[0.3em] font-sans font-bold px-3 py-2 border self-start sm:self-auto whitespace-nowrap"
            style={{ color: C.burgundy, borderColor: C.burgundy }}
          >
            Strictly Confidential
          </div>
        </div>

        {/* Body Grid */}
        <div
          className="grid md:grid-cols-5"
          style={{ border: `1px solid ${C.black}`, borderTop: "none" }}
        >
          {/* Sidebar */}
          <div
            className="md:col-span-2 p-6 md:p-7 flex flex-col gap-0 border-b md:border-b-0 md:border-r"
            style={{ backgroundColor: C.black, borderColor: "#333" }}
          >
            <div style={{ width: 28, height: 2, backgroundColor: C.burgundy, marginBottom: 20 }} />

            <ContactItem icon={<FaMapMarkerAlt size={11} />} label="Office">
              2/3A, LGF, Jangpura A, New Delhi,<br/>
Delhi 110001
            </ContactItem>

            <ContactItem icon={<FaPhoneAlt size={11} />} label="Phone">
              <a href="tel:+919625975135" className="text-white/85 hover:text-white transition-colors">
                +91 70425 13698 <br/> +91 87682 62710
              </a>
            </ContactItem>

            <ContactItem icon={<FaEnvelope size={11} />} label="Email">
              <a href="mailto:info@raiandassocietees.in" className="text-white/85 hover:text-white transition-colors break-all">
                info@raiandassocietees.in
              </a>
            </ContactItem>

            <a
              href="https://wa.me/919625975135"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center gap-3 mt-5 px-4 py-3 transition-opacity hover:opacity-80"
              style={{ backgroundColor: C.burgundy }}
            >
              <FaWhatsapp size={15} color={C.white} />
              <span className="text-[9px] uppercase tracking-[0.3em] font-sans font-bold text-white">
                WhatsApp Us
              </span>
            </a>

            <div
              className="mt-auto pt-5 text-[9px] uppercase tracking-[0.3em] font-sans font-bold"
              style={{ color: "rgba(255,255,255,0.25)", borderTop: "1px solid rgba(255,255,255,0.08)", marginTop: 24, paddingTop: 16 }}
            >
              Mon – Sat &nbsp;·&nbsp; 09:00 – 19:00
            </div>
          </div>

          {/* Form */}
          <form
            onSubmit={handleSubmit}
            className="md:col-span-3 p-6 md:p-7 flex flex-col gap-4"
            style={{ backgroundColor: C.white }}
          >
            {/* Row 1 */}
            <div className="grid sm:grid-cols-2 gap-4">
              <Field label="Full Name" name="name" type="text"
                placeholder="Your full name" value={formData.name} onChange={handleChange} required />
              <Field label="Email Address" name="email" type="email"
                placeholder="your@email.com" value={formData.email} onChange={handleChange} required />
            </div>

            {/* Row 2 */}
            <div className="grid sm:grid-cols-2 gap-4">
              <Field label="Phone" name="phone" type="tel"
                placeholder="+91 00000 00000" value={formData.phone} onChange={handleChange} />
              <div className="flex flex-col gap-1.5">
                <label className="text-[9px] uppercase tracking-[0.35em] font-black font-sans" style={{ color: C.black }}>
                  Practice Area
                </label>
                <select
                  name="area"
                  value={formData.area}
                  onChange={handleChange}
                  className="text-sm font-sans px-4 py-2.5 outline-none"
                  style={{ border: `1.5px solid ${C.black}`, color: C.black, backgroundColor: C.white, appearance: "none" }}
                  onFocus={(e) => (e.target.style.borderColor = C.burgundy)}
                  onBlur={(e) => (e.target.style.borderColor = C.black)}
                >
                  <option value="">Select matter type</option>
                  {PRACTICE_AREAS.map((a) => <option key={a}>{a}</option>)}
                </select>
              </div>
            </div>

            <Field label="Subject" name="subject" type="text"
              placeholder="Brief subject of your matter" value={formData.subject} onChange={handleChange} />

            <div style={{ height: 1, backgroundColor: "#e8e5e0" }} />

            {/* Textarea */}
            <div className="flex flex-col gap-1.5">
              <label className="text-[9px] uppercase tracking-[0.35em] font-black font-sans" style={{ color: C.black }}>
                Message
              </label>
              <textarea
                name="message"
                rows={4}
                required
                placeholder="Describe your legal matter in brief..."
                value={formData.message}
                onChange={handleChange}
                className="w-full text-sm font-sans px-4 py-3 outline-none resize-none placeholder-black/25"
                style={{ border: `1.5px solid ${C.black}`, color: C.black, backgroundColor: C.white }}
                onFocus={(e) => (e.target.style.borderColor = C.burgundy)}
                onBlur={(e) => (e.target.style.borderColor = C.black)}
              />
            </div>

            {/* Submit Row */}
            <div className="flex items-center gap-4 mt-1">
              <button
                type="submit"
                className="flex-1 py-3.5 text-[10px] font-black uppercase tracking-[0.35em] font-sans transition-all duration-300"
                style={{ backgroundColor: C.black, color: C.white, border: `2px solid ${C.black}` }}
                onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = C.burgundy; e.currentTarget.style.borderColor = C.burgundy; }}
                onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = C.black; e.currentTarget.style.borderColor = C.black; }}
              >
                Send via WhatsApp →
              </button>
              <p className="text-[10px] font-sans text-gray-400 leading-relaxed max-w-[90px]">
                We respond within 24 hours.
              </p>
            </div>
          </form>
        </div>
        </div>
<div/>
      {/* Bottom Rule */}
      <div style={{ height: 3, backgroundColor: C.burgundy }} />
    </section>
  );
};

// ── Helpers ───────────────────────────────────────────────────────────────────

const Field = ({ label, name, type, placeholder, value, onChange, required }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-[9px] uppercase tracking-[0.35em] font-black font-sans" style={{ color: "#111" }}>
      {label}
    </label>
    <input
      type={type}
      name={name}
      required={required}
      placeholder={placeholder}
      value={value}
      onChange={onChange}
      className="w-full text-sm font-sans px-4 py-2.5 outline-none placeholder-black/25"
      style={{ border: "1.5px solid #111", color: "#111", backgroundColor: "#fff" }}
      onFocus={(e) => (e.target.style.borderColor = "#7A1F2B")}
      onBlur={(e) => (e.target.style.borderColor = "#111")}
    />
  </div>
);

const ContactItem = ({ icon, label, children }) => (
  <div className="py-3.5" style={{ borderBottom: "1px solid rgba(255,255,255,0.08)" }}>
    <div className="flex items-center gap-1.5 mb-1.5">
      <span style={{ color: "#7A1F2B" }}>{icon}</span>
      <span className="text-[9px] uppercase tracking-[0.3em] font-sans font-black" style={{ color: "rgba(255,255,255,0.3)" }}>
        {label}
      </span>
    </div>
    <div className="text-[12px] font-sans leading-relaxed" style={{ color: "rgba(255,255,255,0.82)" }}>
      {children}
    </div>
  </div>
);

export default ContactForm;